import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, ButtonToolbar, Modal, Table,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

import CommonService from '../../services/CommonService';
import global from '../../global';

class TransactionModal extends PureComponent {
   static propTypes = {
      salesId: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]).isRequired,
      toggle: PropTypes.func.isRequired,
      modal: PropTypes.bool,
      total: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]),
      amountPaid: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]),
      drnumber: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]),
      balance: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]),
   };

   static defaultProps = {
      modal: false,
      total: 0,
      amountPaid: 0,
      drnumber: '',
      balance: 0,
   };

   constructor() {
      super();
      this.state = {
         list: [],
      };
      this.isLoading = false;
   }

   componentDidMount() {
      const { salesId } = this.props;
      this.isLoading = true;
      this.onLoadProductSales(salesId);
   }

   componentWillReceiveProps(nextProps) {
      this.isLoading = true;
      this.onLoadProductSales(nextProps.salesId);
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadProductSales = async (salesid) => {
      try {
         const response = await CommonService.getRows(`salesproduct/salesid/${salesid}`);
         if (this.isLoading && response) {
            this.setState({ list: response });
         }
      } catch (err) {
         console.log('Error: ', err.message);
      }
      this.isLoading = false;
   }

   render() {
      const {
         modal, toggle, total, amountPaid, balance, drnumber,
      } = this.props;
      const { list } = this.state;

      return (
         <Modal
            isOpen={modal}
            className="modal-dialog--primary modal-dialog--header modal-lg"
         >
            <div className="modal__header bg_blue">
               <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
               <h4 className="bold-text  modal__title">Products {drnumber !== '' ? ` - [ ${drnumber} ]` : ''}</h4>
            </div>
            <div className="modal__body p-x-10 p-y-15">
               <Table className="no_hover" id="product_table" responsive>
                  <thead>
                     <tr>
                        <th>Product</th>
                        <th width="25%" className="text-center">Quantity</th>
                        <th width="25%" className="text-center">Unit Cost</th>
                        <th width="18%" className="text-center">Total</th>
                     </tr>
                  </thead>
                  <tbody>
                  {
                     list !== false || list.length > 0 ? list.map((item, key) => {
                        const totalQuantity = item.quantity !== '' ? global.parseToNumber(item.quantity, 'float') : 0;
                        const unitCost = item.unit_cost !== '' ? global.parseToNumber(item.unit_cost, 'float') : 0;
                        const totalSales = item.product_total !== '' ? global.parseToNumber(item.product_total, 'float') : 0;

                        return (
                           <tr key={`productList${key + 1}`} className="text-center">
                              <td className="text-left">{item.product_name}</td>
                              <td>{global.numberFormat(totalQuantity)} kgs.</td>
                              <td className="text-primary"><span className="m-r-3">&#x20B1;</span> {global.numberFormat(unitCost)}</td>
                              <td className="text-success"><span className="m-r-3">&#x20B1;</span> {global.numberFormat(totalSales)}</td>
                           </tr>
                        );
                     }) : (
                        <tr className="text-center">
                           <td colSpan="7">No data available..</td>
                        </tr>
                     )
                  }
                  </tbody>
               </Table>

               <div className="table-foot">
                  <Table className="no_hover" id="product_table" responsive>
                     <tbody>
                        <tr>
                           <td colSpan="3"><span className="bold">Total</span></td>
                           <td className="text-center" width="18%"><span className="m-r-2">&#x20B1;</span> {total !== null ? total : 0}</td>
                        </tr>
                        <tr>
                           <td colSpan="3"><span className="bold">Amount Paid</span></td>
                           <td className="text-center" width="18%"><span className="m-r-2">&#x20B1;</span> {amountPaid !== null ? amountPaid : 0}</td>
                        </tr>
                        <tr>
                           <td colSpan="3"><span className="bold">Balance</span></td>
                           <td className="text-center" width="18%"><span className="m-r-2">&#x20B1;</span> {balance !== null ? balance : 0}</td>
                        </tr>
                     </tbody>
                  </Table>
               </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button onClick={toggle}>Close</Button>
            </ButtonToolbar>
         </Modal>
      );
   }
}

export default reduxForm({
  form: 'transaction_form', // a unique identifier for this form
})(withTranslation('common')(TransactionModal));
